import {
  isValidAlert,
  isValidOutput,
  isValidQuestion,
  isValidRecursiveQuestion,
} from "./blockValidation";

const getFixedItemInCalculation = (output, target) =>
  output.reduce((acc, output) => {
    if (!output?.calculation?.length) {
      return acc;
    }

    return [
      ...acc,
      ...output.calculation.reduce((acc, calc) => {
        if (calc[0] === "{") {
          const parsedCalc = JSON.parse(calc);
          const item = parsedCalc[target];

          if (item?.value) {
            return [...acc, item.value];
          }
        }
        return acc;
      }, []),
    ];
  }, []);

export const getFixedProductInCalculation = (output) => getFixedItemInCalculation(output, 'product');
export const getFixedSystemInCalculation = (output) => getFixedItemInCalculation(output, 'system');

const getQuestionOptions = (rowVisibleByUserType, block) =>
  rowVisibleByUserType.filter(
    (r) =>
      r.type === "option" &&
      r.input_id === block.id &&
      (r.option_value || r.product_id|| r.system_id)
  );

const getRowVisibleByUserType = (data, selectedRoleType) => {
  let rowVisibleByUserType = data;

  // only for preview because on real case selectedRoleType is fixed
  if (selectedRoleType) {
    rowVisibleByUserType = data.filter(
      (d) =>
        (d.r_perm.indexOf("public") >= 0 ||
          d.r_perm.indexOf(`role_type_${selectedRoleType}`) >= 0)
    );
  }

  return rowVisibleByUserType;
}

const prepareConfigurationStep = (data, selectedRoleType, mainServiceId) => {
  let rowVisibleByUserType = getRowVisibleByUserType(data, selectedRoleType);

  const buildSteps = (blocksVisibleByUserType, serviceId, serviceBlockId, serviceBlockVersion) => {
    return blocksVisibleByUserType.filter((row) => {
      return (row.type === "step" && row.service_id === serviceId) || (row.type === "service" && row.active)
      }
    ).reduce((acc, s) => {
      if (s.type === "service") {
        const nestedData = blocksVisibleByUserType.filter(
          (block) => block.service_id === s?.metadata_?.chosen_service_id
        );
        return [
          ...acc,
          ...buildSteps(nestedData, s?.metadata_?.chosen_service_id, s.id, s.version),
        ]
      }

      const blocks = blocksVisibleByUserType
        .filter(
          (block) =>
            block.step_id === s.id &&
            (isValidQuestion(block) ||
              isValidAlert(block) ||
              isValidOutput(block) ||
              isValidRecursiveQuestion(block))
        )
        .map((block) => {
          // retrieve question options
          if (isValidQuestion(block)) {
            return {
              ...block,
              ...(serviceBlockId && {
                service_block_id: serviceBlockId,
                service_block_version: serviceBlockVersion
              }),
              options: getQuestionOptions(blocksVisibleByUserType, block).map(
                (option) => {
                  return {
                    ...option,
                    ...(serviceBlockId && {
                      service_block_id: serviceBlockId,
                      service_block_version: serviceBlockVersion
                    }),
                  }
                }
              ),
            };
          }

          // retrieve recursive question formatted
          if (isValidRecursiveQuestion(block)) {
            return {
              ...block,
              ...(serviceBlockId && {
                service_block_id: serviceBlockId,
                service_block_version: serviceBlockVersion
              }),
              blocks: blocksVisibleByUserType
                .filter((r) => r.recursive_question_id === block.id)
                .map((b) => {
                  if (isValidQuestion(b)) {
                    return {
                      ...b,
                      ...(serviceBlockId && {
                        service_block_id: serviceBlockId,
                        service_block_version: serviceBlockVersion
                      }),
                      options: getQuestionOptions(blocksVisibleByUserType, b).map(
                        (option) => {
                          return {
                            ...option,
                            ...(serviceBlockId && {
                              service_block_id: serviceBlockId,
                              service_block_version: serviceBlockVersion
                            }),
                          }
                        }
                      ),
                    };
                  }
                  return b;
                }),
            };
          }
          return {
            ...block,
            ...(serviceBlockId && {
              service_block_id: serviceBlockId,
              service_block_version: serviceBlockVersion
            }),
          };
        });

      const output = blocks.filter((b) => isValidOutput(b)).map(
        (b) => {
          return {
            ...b,
            ...(serviceBlockId && {
              service_block_id: serviceBlockId,
              service_block_version: serviceBlockVersion
            }),
          }
        }
      );

      // filter recursive output
      const recursiveQuestions = blocks.filter((b) =>
        isValidRecursiveQuestion(b)
      ).map((b) => {
        return {
          ...b,
          ...(serviceBlockId && {
            service_block_id: serviceBlockId,
            service_block_version: serviceBlockVersion
          }),
        }
      });

      // retrieve fixed products
      const products = getFixedProductInCalculation([
        ...output,
        ...recursiveQuestions.reduce(
          (acc, q) => [...acc, ...q.blocks.filter((b) => isValidOutput(b))],
          []
        ),
      ]);

      // retrieve fixed systems
      const systems = getFixedSystemInCalculation([
        ...output,
        ...recursiveQuestions.reduce(
          (acc, q) => [...acc, ...q.blocks.filter((b) => isValidOutput(b))],
          []
        ),
      ]);

      return [
        ...acc,
        {
          ...s,
          questions: blocks.filter((b) => isValidQuestion(b)),
          alerts: blocks.filter((b) => isValidAlert(b)),
          output,
          recursiveQuestions,
          blocks,
          products,
          systems,
          ...(serviceBlockId && {
            service_block_id: serviceBlockId,
            service_block_version: serviceBlockVersion
          }),
        },
      ];
    }, [])
      .filter((row) => row.blocks?.length || row.steps?.length);
  }
  const x = buildSteps(rowVisibleByUserType, mainServiceId);
  return x;
};

export default prepareConfigurationStep;
